'use strict'
const repeaterHooks = require('./hooks/repeaterHooks');

module.exports = {
  repeaters: repeaterHooks
};


// WEBPACK FOOTER //
// ./src/RMIHooks/componentsHooks.js